import { render } from "./소아청소년과.vue?vue&type=template&id=7ae2f578"
import script from "./소아청소년과.vue?vue&type=script&lang=js"
export * from "./소아청소년과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__